<template name="visitorList">
  <div class="visitor-list-view">
    <div class="visitor-list-content">
      <div
        class="visitor-content"
        :class="{'hide-visitor': !this.showVisitor, 'passed-invite': inviteStatus !== 1}">
        <div class="view-main" v-if="visitorDataList.length">
          <div class="visitor-list">
            <div class="view-header visiteInformation">
              <h4>{{$t('visitorInfo')}}</h4>
              <div v-on:click="toggleVisitor" class="btn-toggle">
                <span v-if="!this.showVisitor">{{$t('Expand')}}<i class="iconfont icon-down"></i></span>
                <span v-else>{{$t('Collapse')}}<i class="iconfont icon-up"></i></span>
              </div>
            </div>
            <transition name="slide-fade">
              <div class="view-content" v-show="this.showVisitor" ref="visitorList">
                <div class="visitor-row" :key="index" v-for="(item, index) in visitorDataList" >
                  <span class="visitor-status deleteOneVistor" @click="deleteVisitor(item.materialOptionInfoList.length, item.visitorId)" :data-visitorId="item.visitorId" :data-value="item.materialOptionInfoList.length" v-show="item.canDeleteVisitor && item.materialOptionInfoList.length==0" v-if="showAddInvisitor">
                     {{$t('DeleteVisitor')}}
                  </span>
                  <span class="visitor-status" v-show="item.materialOptionInfoList.length!=0" v-if="item.visitorStatus == 1 || item.materialApproverStatus == 2 || item.materialApproverStatus == 3 "
                    :class="item.materialApproverStatus == 3 ? 'status-grey' : 'status-red' ">
                    {{ item.materialApproverStatusDesc }}
                  </span>
                  <span class="visitor-status" v-show="item.materialOptionInfoList.length !=0" v-else
                    :class="item.visitorStatus == 5 ? 'status-grey' : 'status-red' ">
                    {{ item.visitorStatusDesc }}
                  </span>
                  <div class="name row">
                    <label class="checked">
                     <input type='checkbox' v-show="isTicket && item.hasMaterial" v-model='checkList'  name='checkboxinput' class='input-checkbox' :value=item.visitorId>{{ item.visitorName }}
                    </label>
                  </div>
                  <div class="detail-info" v-if="item.isPriVisitor">
                    <div class="company-info" v-if="companyMaterial.length">
                      <h5 class="title" v-if="companyMaterial.length"><img src="../../assets/images/qiye.png">{{$t('CompanyInfo')}}</h5>
                      <div class="info-content">
                        <dl class="row" v-show="item.isCompany" v-if="item.materialType==3 || item.materialType==4 || item.materialType==5" v-for="(item, index) in companyMaterial">
                          <dt class="col-4">{{item.materialTitleTemplate}}</dt>
                          <dd class="col-8 info-text">{{item.answer}}</dd>
                        </dl>
                        <dl  class="row" v-for="(one, index) in answerListCompany.materialOne">
                          <dt class="col-4">{{one.topic}}</dt>
                          <dd class="col-8 info-text">{{one.answer}}</dd>
                        </dl>
                        <dl  class="row" v-for="(one, index) in answerListCompany.materialTwo">
                          <dt class="col-4">{{one.topic}}</dt>
                          <dd class="col-8 spcial">
                            <dl  class="row" v-for="(one, idx) in one.answer">
                              <dd class="col-12">{{one}}</dd>
                            </dl>
                          </dd>
                        </dl>
                        <dl  class="row" v-for="(one, index) in answerListCompany.materialEnght">
                          <dt class="col-4">{{one.topic}}</dt>
                          <dd class="col-8 info-text" :class="{'redColor': one.optionCode == 4}">
                            <span>{{one.answer}}</span></dd>
                        </dl>
                        <dl class="row" v-if="(item.isCompany && item.materialType==9) || (item.isCompany && item.materialType==6) || (item.isCompany && item.materialType==7) " v-for="(item, index) in companyMaterial">
                          <dt class="col-4" :data-value="item.materialType">{{item.materialTitleTemplate}}</dt>
                          <dd class="col-8 info-text" @click="lookImgs(item.answer)" v-if="item.materialType != 6">
                            <span  class="lookImgs" :data-value="item.answer">{{$t('ViewImage')}}</span>
                          </dd>
                          <dd class="col-8 info-text" @click="lookAccessory(item.answer)" v-if="item.materialType == 6">
                            <span  class="lookImgs" :data-value="item.answer">{{$t('ViewAttachedFile')}}</span>
                          </dd>
                        </dl>
                        </dl>
                       <!--  <dl class="row" v-if="item.isCompany && (item.materialType==6)" v-for="(item, index) in companyMaterial">
                          <dt class="col-4" :data-value="item.materialType" v-if="item.materialType == 6">{{item.materialTitleTemplate}}</dt>
                          <dd class="col-8 info-text" @click="lookAccessory(item.answer)">
                            <span  class="lookImgs" :data-value="item.answer">{{$t('ViewAttachedFile')}}</span>
                          </dd>
                        </dl>
                        <dl class="row" v-if="item.isCompany && (item.materialType==7)" v-for="(item, index) in companyMaterial">
                          <dt class="col-4" :data-value="item.materialType">{{item.materialTitleTemplate}}</dt>
                          <dd class="col-8 info-text" @click="lookImgs(item.answer)">
                            <span  class="lookImgs" :data-value="item.answer">{{$t('ViewImage')}}</span>
                          </dd>
                        </dl> -->
                      </div>
                    </div>
                    <div class="personal-info" >
                      <h5 class="title"><img src="../../assets/images/user.png"/>{{$t('visitorInfo')}}</h5>
                      <div class="info-content">
                        <dl class="row">
                          <dt class="col-4">{{$t('name')}}</dt>
                          <dd class="col-8  info-text">{{item.visitorName}}</dd>
                        </dl>
                        <dl class="row" v-if="item.visitorPhoneNumber">
                          <dt class="col-4">{{$t('mobile')}}</dt>
                          <dd class="col-8 info-text">{{item.visitorPhoneNumber}}</dd>
                        </dl>
                        <dl class="row" v-if="item.visitorEmail">
                          <dt class="col-4">{{$t('email')}}</dt>
                          <dd class="col-8 info-text">{{item.visitorEmail}}</dd>
                        </dl>
                      </div>
                      <div class="info-content" v-if="perosonMaterial.length">
                        <dl class="row" v-show="!item.isCompany" v-if="item.materialType==3 || item.materialType==4 || item.materialType==5"
                          v-for="(item, index) in perosonMaterial">
                          <dt class="col-4" :data-value="item.materialType">{{item.materialTitleTemplate}}</dt>
                          <dd class="col-8 info-text" :class="{'redColor': item.optionCode == 3}">
                            <span>{{item.answer}}</span>
                          </dd>
                        </dl>
                        <dl  class="row" v-for="(one, index) in answerListPerson.materialOne">
                          <dt class="col-4">{{one.topic}}</dt>
                          <dd class="col-8 info-text">{{one.answer}}</dd>
                        </dl>
                        <dl  class="row" v-for="(one, index) in answerListPerson.materialTwo">
                          <dt class="col-4">{{one.topic}}</dt>
                          <dd class="col-8 spcial">
                            <dl  class="row" v-for="(one, idx) in one.answer">
                              <dd class="col-12">{{one}}</dd>
                            </dl>
                          </dd>
                        </dl>
                        <dl  class="row" v-for="(one, index) in answerListPerson.materialEnght">
                          <dt class="col-4">{{one.topic}}</dt>
                          <dd class="col-8 info-text" :class="{'redColor': one.optionCode == 4 && one.status == 0}">
                            <span>{{one.answer}}</span></dd>
                        </dl>
                        <dl class="row" v-if="(!item.isCompany&& item.materialType==9) || (!item.isCompany&& item.materialType==6) || (!item.isCompany&& item.materialType==7)" v-for="(item, index) in perosonMaterial">
                          <dt class="col-4" :data-value="item.materialType">{{item.materialTitleTemplate}}</dt>
                          <dd class="col-8 info-text"  @click="lookImgs(item.answer)" v-if="item.materialType != 6">
                            <span :data-value="item.answer" class="lookImgs">{{$t('ViewImage')}}</span>
                          </dd>
                          <dd class="col-8 info-text" @click="lookAccessory(item.answer)" v-if="item.materialType == 6">
                            <span class="lookImgs" :data-value="item.answer">{{$t('ViewAttachedFile')}}</span>
                          </dd>
                        </dl>
                        <!-- <dl class="row" v-if="!item.isCompany&& (item.materialType==6)" v-for="(item, index) in perosonMaterial">
                          <dt class="col-4" :data-value="item.materialType" >{{item.materialTitleTemplate}}</dt>
                          <dd class="col-8 info-text" @click="lookAccessory(item.answer)">
                            <span class="lookImgs" :data-value="item.answer">{{$t('ViewAttachedFile')}}</span>
                          </dd>
                        </dl>
                        <dl class="row" v-if="!item.isCompany&& (item.materialType==7)" v-for="(item, index) in perosonMaterial">
                          <dt class="col-4" :data-value="item.materialType">{{item.materialTitleTemplate}}</dt>
                          <dd class="col-8 info-text"  @click="lookImgs(item.answer)">
                            <span :data-value="item.answer" class="lookImgs">{{$t('ViewImage')}}</span>
                          </dd>
                        </dl> -->
                      </div>
                    </div>
                    <div class="course-info" v-if="item.lessonList.length">
                      <h5 class="title"><img src="../../assets/images/gongsijianjie.png"/>{{$t('course')}}<span>({{$t('learningProgress')}}: {{lessonOverdue[index]}}/{{item.lessonList.length}})</span></h5>
                      <div v-on:click="toggleVisitorTrain(index)" class="btn-toggle-train">
                        <span ref="downArrow">{{$t('Expand')}}<i class="iconfont icon-down"></i></span>
                        <span ref="upArrow" style="display: none;">{{$t('Collapse')}}<i class="iconfont icon-up"></i></span>
                      </div>
                      <div class="info-content" ref="child" style="display: none;">
                        <dl class="row" v-for="(item, index) in item.lessonList">
                          <dt class="col-9">{{item.lessonName}}</dt>
                          <dd class="col-3 status">{{item.lessonStatusDesc}}</dd>
                        </dl>
                      </div>
                    </div>
                    <div class="reject-info" v-if="item.rejectReason">
                      <div><span>{{$t('reason')}}:  {{item.rejectReason}}</span></div>
                    </div>
                    <!-- <div>qrCode==={{item.qrCode}}/ {{showAddInvisitor}}/
                        {{item.materialOptionInfoList.length}}/ {{item.canDeleteMaterial}}/ {{item.canEditMaterial}}/ {{item.canEditCarNumber}}
                    </div> -->
                    <div class="operation row">
                      <div class="delete" :class="{'status-only': (((item.materialOptionInfoList.length && item.canDeleteMaterial && showAddInvisitor) ? 1 : 0 ) + ((item.canEditMaterial && item.materialOptionInfoList.length && showAddInvisitor) ? 1 : 0) + ((item.materialOptionInfoList.length && !item.canEditMaterial && item.canEditCarNumber && showAddInvisitor) ? 1 : 0) + ((item.qrCode) ? 1 : 0)) == 1 }" v-if="item.materialOptionInfoList.length &&item.canDeleteMaterial && showAddInvisitor" @click="deleteVisitor(item.materialOptionInfoList.length, item.visitorId)" :data-visitorId="item.visitorId" :data-value="item.materialOptionInfoList.length" ><span :data-value="item.materialOptionInfoList.length" :data-visitorId="item.visitorId">{{$t('delete')}}</span></div>

                      <div class="modify" :class="{'status-only': (((item.materialOptionInfoList.length && item.canDeleteMaterial && showAddInvisitor) ? 1 : 0 ) + ((item.canEditMaterial && item.materialOptionInfoList.length && showAddInvisitor) ? 1 : 0) + ((item.materialOptionInfoList.length && !item.canEditMaterial && item.canEditCarNumber && showAddInvisitor) ? 1 : 0) + ((item.qrCode) ? 1 : 0)) == 1}" v-if="item.canEditMaterial && item.materialOptionInfoList.length && showAddInvisitor" :data-visitorId="item.visitorId" @click="editVisitor($event,index)"><span :data-visitorId="item.visitorId">{{$t('modify')}}</span></div>

                      <div class="onlyupdateCardId" :class="{'status-only':  (((item.materialOptionInfoList.length && item.canDeleteMaterial && showAddInvisitor) ? 1 : 0 ) + ((item.canEditMaterial && item.materialOptionInfoList.length && showAddInvisitor) ? 1 : 0) + ((item.materialOptionInfoList.length && !item.canEditMaterial && item.canEditCarNumber && showAddInvisitor) ? 1 : 0) + ((item.qrCode) ? 1 : 0)) == 1}"  @click="updateCardNumber(isPriVisitorCardNumber ? isPriVisitorCardNumber.answer : '', item.visitorId,item.carNumberIsRequired)"  v-if="item.materialOptionInfoList.length && !item.canEditMaterial && item.canEditCarNumber && showAddInvisitor" >
                        <span>{{$t('AddorEditLicense')}}</span>
                      </div>

                      <div class="onylydetail-status" :class="{'status-only':  (((item.materialOptionInfoList.length && item.canDeleteMaterial && showAddInvisitor) ? 1 : 0 ) + ((item.canEditMaterial && item.materialOptionInfoList.length && showAddInvisitor) ? 1 : 0) + ((item.materialOptionInfoList.length && !item.canEditMaterial && item.canEditCarNumber && showAddInvisitor) ? 1 : 0) + ((item.qrCode) ? 1 : 0)) == 1}" v-if="item.qrCode" @click="toggleQR(item.qrCode)">
                          <img src="../../assets/images/erweimasaomiao.png"><span>{{$t('CampusCode')}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="detail-info" v-else>
                    <div class="personal-info">
                      <h5 class="title"><img src="../../assets/images/user.png">{{$t('visitorInfo')}}</h5>
                      <div class="info-content">
                        <dl class="row">
                          <dt class="col-4">{{$t('name')}}</dt>
                          <dd class="col-8  info-text">{{item.visitorName}}</dd>
                        </dl>
                        <dl class="row" v-if="item.visitorPhoneNumber">
                          <dt class="col-4">{{$t('mobile')}}</dt>
                          <dd class="col-8 info-text">{{item.visitorPhoneNumber}}</dd>
                        </dl>
                        <dl class="row" v-if="item.visitorEmail">
                          <dt class="col-4">{{$t('email')}}</dt>
                          <dd class="col-8 info-text">{{item.visitorEmail}}</dd>
                        </dl>
                      </div>
                      <div class="info-content" v-if="newPerosonMaterial.length">
                        <dl class="row" v-if="array.materialType==3 || array.materialType==4 || array.materialType==5" v-for="(array, index) in newPerosonMaterial[index].isPersonMaterial">
                          <dt class="col-4">{{array.materialTitleTemplate}}</dt>
                          <dd class="col-8 info-text" :class="{'redColor': array.optionCode == 3}"><span>{{array.answer}}</span></dd>
                        </dl>
                        <dl class="row"
                         v-for="(array, idx) in OtherInvitorPerosonMaterial[index].materialOne">
                          <dt class="col-4">{{array.topic}}</dt>
                          <dd class="col-8 info-text">
                            <span>{{array.answer}}</span>
                          </dd>
                        </dl>
                        <dl class="row"
                         v-for="(array, idx) in OtherInvitorPerosonMaterial[index].materialTwo">
                          <dt class="col-4">{{array.topic}}</dt>
                          <dd class="col-8 spcial">
                            <dl  class="row" v-for="(one, index) in array.answer">
                              <dd class="col-12">{{one}}</dd>
                            </dl>
                          </dd>
                        </dl>
                        <dl class="row"  v-for="(array, idx) in OtherInvitorPerosonMaterial[index].materialEnght">
                          <dt class="col-4">{{array.topic}}</dt>
                          <dd class="col-8 info-text"  :class="{'redColor': array.optionCode == 4 && array.status == 0}">
                            <span>{{array.answer}}</span>
                          </dd>
                        </dl>
                        <dl class="row" v-if="array.materialType==9 || array.materialType==6 || array.materialType==7" v-for="(array, index) in newPerosonMaterial[index].isPersonMaterial">
                          <dt class="col-4" :data-value="array.materialType">{{array.materialTitleTemplate}}</dt>
                          <dd class="col-8 info-text" @click="lookImgs(array.answer)" v-if="array.materialType != 6">
                            <span  class="lookImgs" :data-value="array.answer">{{$t('ViewImage')}}</span>
                          </dd>
                          <dd class="col-8 info-text"  @click="lookAccessory(array.answer)" v-if="array.materialType==6">
                            <span class="lookImgs" :data-value="array.answer">{{$t('ViewAttachedFile')}}{{item.answer}}</span>
                          </dd>
                        </dl>
                       <!--  <dl class="row" v-if="array.materialType==6" v-for="(array, index) in newPerosonMaterial[index].isPersonMaterial">
                          <dt class="col-4" :data-value="array.materialType">{{array.materialTitleTemplate}}</dt>
                          <dd class="col-8 info-text"  @click="lookAccessory(array.answer)">
                            <span class="lookImgs" :data-value="array.answer">{{$t('ViewAttachedFile')}}{{item.answer}}</span>
                          </dd>
                        </dl>
                        <dl class="row" v-if="array.materialType==7" v-for="(array, index) in newPerosonMaterial[index].isPersonMaterial">
                          <dt class="col-4" :data-value="array.materialType">{{array.materialTitleTemplate}}</dt>
                          <dd class="col-8 info-text" @click="lookImgs(array.answer)">
                            <span  class="lookImgs" :data-value="array.answer">{{$t('ViewImage')}}</span>
                          </dd>
                        </dl> -->
                      </div>
                    </div>
                    <div class="course-info" v-if="item.lessonList.length">
                      <h5 class="title"><img src="../../assets/images/gongsijianjie.png">{{$t('course')}}<span>({{$t('learningProgress')}}: {{lessonOverdue[index]}}/{{item.lessonList.length}})</span></h5>
                      <div v-on:click="toggleVisitorTrain(index)" class="btn-toggle-train">
                        <span ref="downArrow">
                          {{$t('Expand')}}<i class="iconfont icon-down"></i>
                        </span>
                        <span ref="upArrow" style="display: none;">{{$t('Collapse')}}<i class="iconfont icon-up"></i></span>
                      </div>
                      <div class="info-content" ref="child" style="display: none;">
                        <dl class="row" v-for="(item, index) in item.lessonList">
                          <dt class="col-9">{{item.lessonName}}</dt>
                          <dd class="col-3">{{item.lessonStatusDesc}}</dd>
                        </dl>
                      </div>
                    </div>
                    <div class="reject-info" v-if="item.rejectReason">
                      <div><span>{{$t('reason')}}:  {{item.rejectReason}}</span></div>
                    </div>
                    <div class="operation row" >
                      <div class="delete" :class="{'status-only': (((item.materialOptionInfoList.length && item.canDeleteMaterial && showAddInvisitor) ? 1 : 0 ) + ((item.canEditMaterial && item.materialOptionInfoList.length && showAddInvisitor) ? 1 : 0) + ((item.materialOptionInfoList.length && !item.canEditMaterial && item.canEditCarNumber && showAddInvisitor) ? 1 : 0) + ((item.qrCode) ? 1 : 0)) == 1 }" v-if="item.canDeleteMaterial && showAddInvisitor" @click="deleteVisitor(item.materialOptionInfoList.length, item.visitorId)" :data-visitorId="item.visitorId" :data-value="item.materialOptionInfoList.length" ><span>{{$t('delete')}}</span></div>

                      <div class="modify" :class="{'status-only': (((item.materialOptionInfoList.length && item.canDeleteMaterial && showAddInvisitor) ? 1 : 0 ) + ((item.canEditMaterial && item.materialOptionInfoList.length && showAddInvisitor) ? 1 : 0) + ((item.materialOptionInfoList.length && !item.canEditMaterial && item.canEditCarNumber && showAddInvisitor) ? 1 : 0) + ((item.qrCode) ? 1 : 0)) == 1}" v-if="item.canEditMaterial && item.materialOptionInfoList.length && showAddInvisitor" :data-visitorId="item.visitorId" @click="editVisitor($event,index)"><span :data-visitorId="item.visitorId">{{$t('modify')}}</span></div>

                      <div class="onlyupdateCardId" :class="{'status-only': (((item.materialOptionInfoList.length && item.canDeleteMaterial && showAddInvisitor) ? 1 : 0 ) + ((item.canEditMaterial && item.materialOptionInfoList.length && showAddInvisitor) ? 1 : 0) + ((item.materialOptionInfoList.length && !item.canEditMaterial && item.canEditCarNumber && showAddInvisitor) ? 1 : 0) + ((item.qrCode) ? 1 : 0)) == 1}"  @click="updateCardNumber(newPerosonMaterial[index].isPersonMaterial.findIndex(x => x.optionCode ==3) == -1 ? '' :newPerosonMaterial[index].isPersonMaterial.find(x => x.optionCode ==3).answer, item.visitorId, item.carNumberIsRequired)"  v-if="!item.canEditMaterial && item.canEditCarNumber && showAddInvisitor" >
                        <span>{{$t('AddorEditLicense')}}</span>
                      </div>

                      <div class="onylydetail-status" :class="{'status-only': (((item.materialOptionInfoList.length && item.canDeleteMaterial && showAddInvisitor) ? 1 : 0 ) + ((item.canEditMaterial && item.materialOptionInfoList.length && showAddInvisitor) ? 1 : 0) + ((item.materialOptionInfoList.length && !item.canEditMaterial && item.canEditCarNumber && showAddInvisitor) ? 1 : 0) + ((item.qrCode) ? 1 : 0)) == 1}" v-if="item.qrCode" @click="toggleQR(item.qrCode)">
                          <img src="../../assets/images/erweimasaomiao.png"><span>{{$t('CampusCode')}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
            <div class="addBtn" v-show="showAddInvisitor" v-if="canAddOthersMaterial || canAddMaterial" @click="emitAddEventToParentScope">
              <div class="addInformation"  v-show="showAddInvisitor"><i class="iconfont icon-add"></i><span>{{$t('VisitorReviewData')}}</span></div>
            </div>
            <div class="tips" v-show="isPrimary && isLimitSubmit && typeAreaRemark!==null && typeAreaRemark !== '' ">
              <i class="iconfont icon-speaker"></i><span>{{typeAreaRemark}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div class="visit-show" v-show="this.photoSwipeModal">
        <div>
          <photoSwipe ref="photoSwiper" @closePhoto="closePhoto"></photoSwipe>
        </div>
      </div>
    </transition>
    <transition>
      <div v-show="this.comifrmModal" class="visit-show">
        <tipModal ref="detailDialogShow"  @closeModal="closeModal"></tipModal>
      </div>
    </transition>
    <transition>
      <div v-show="this.editModal" class="visit-show">
        <EditVisitorDetail 
        :isKOSystem="false" 
        :isExternalSystem="true"
        :materials="this.currentVisitor.materials"
        :showVisitorDetail = "true"
        :isNameEmpty="this.isNameEmpty"
        :isPrimaryVisitor="this.currentVisitor.isPrimaryVisitor"
        :currentVisitor="this.currentVisitor"
        ref="editVisitorShow" @closeEdit="closeEdit" @deleteAnnex="handleDeleteAnnex" @deleteImg="handleDeleteImg" @answer="handleAnswer" @saveCurrent="handleSaveCurrent"></EditVisitorDetail>
      </div>
    </transition>
    <loading :active.sync="isLoading" :color="'#e42029'" :z-index="9999"></loading>
    <div class="qr-wrapper" v-show="isQRShow">
      <div class="qr-content">
        <div class="close-wrapper" @click="toggleQR">
          <i class="iconfont icon-close"></i>
        </div>
        <div class="qr-scroll">
          <qrcode :value="currentQR" :options="{ width: 300, margin: 3.5 }"></qrcode>
          <div class="qr-desc">
            <p>
              {{ areaName }}
            </p>
            <p>
              {{$t('showQRCode')}}
            </p>
            <p v-show="areaAddress">
              {{ areaAddress }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
  import { materialReview, checkPassOrReject, removeMaterial, getExternalVisitorInfo, getExternalMaterialOptions } from '@/utils/api';
  import photoSwipe from '@/components/photoSwipe.vue';
  import tipModal from '@/components/tipModal.vue';
  import EditVisitorDetail from '@/views/external/EditVisitorDetail.vue';
  import { checkNested } from '@/utils/utils';
  import Materials from '@/utils/materials';
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  import Vue from 'vue';
  import VueQrcode from '@chenfengyuan/vue-qrcode';

  let materialsInstance = null;
  Vue.component(VueQrcode.name, VueQrcode);
  import Bus from '@/utils/Bus';
  export default {
    name: 'visitorList',
    props: {inviteStatus: Number,
        isTicket: Boolean,
        inviteId: String,
        isCheckOwner: Boolean,
        areaName: String,
        areaAddress: String,
    },
    components: {
      photoSwipe,
      tipModal,
      EditVisitorDetail,
      Loading,
    },
    data() {
      return {
        areaId: '',
        typeId: '',
        currentVisitor: {
          id: 0,
          userName: '',
          pickedContact: '',
          contact: '',
          isPrimaryVisitor: false,
          materials: [],
        },
        materials: [],
        editModal: false,
        showAddInvisitor: false,
        comifrmModal: false,
        showVisitor: true,
        checkedValue: [],
        items: [],
        approve: 2,
        refuse: 0,
        checkList: [],
        checkboxAll: false,
        isRefuseDisbaled: true,
        isApproveDisabled: true,
        thisModalTip: this.$t('selectOneVisitor'),
        showTrain: false,
        trainList: false,
        companyMaterial: [],
        perosonMaterial: [],
        newCompanyMaterial: [],
        newPerosonMaterial: [],
        lessonOverdue: [],
        lessonOverdueLength: [],
        visitorDataList: [],
        photoSwipeModal: false,
        answerList: [],
        answerListPerson: [],
        answerListCompany: [],
        showVisitorList: false,
        OtherInvitorPerosonMaterial: [],
        visitorListData: false,
        divIndex: -1,
        imgs: ['http://farm4.staticflickr.com/3920/15008465772_383e697089_m.jpg','http://farm4.staticflickr.com/3902/14985871946_86abb8c56f_m.jpg','http://farm7.staticflickr.com/6175/6176698785_7dee72237e_b.jpg'],
        topDetail: {},
        hasMaterialsToFill: true,
        currentMaterials: [],
        primaryVisitor: {
          id: 0,
          userName: '',
          pickedContact: this.$t('mobile'),
          contact: '',
          isPrimaryVisitor: true,
          materials: [],
        },
        visitorDetailList: [],
        idx: -1,
        isNameEmpty: true,
        isLoading: false,
        // QR Code Related Code, Added by Andy
        currentQR: 'empty_qr', // pass '' to <qrcode> seems to cause error
        isQRShow: false,
        hasCarId: false,
        isPriVisitorCardNumber: {},
        lessonList: [],
        canAddMaterial: false,
        canAddOthersMaterial: false,
        isPrimary: false,
        typeAreaRemark: '',
        isLimitSubmit: false,

        // test data 
        isDeleteVisitor: false,
        isEditVisitorMaterial: true,

      };
    },
    watch: {
      'checkList': {
        handler () {
          if(this.checkList.length !=0 ) {
            this.isRefuseDisbaled = false;
            this.isApproveDisabled = false;
          } else {
            this.isRefuseDisbaled = true;
            this.isApproveDisabled = true;
          }
          if(this.checkList.length === this.visitorDataList.length) {
             this.checkboxAll = true;
          } else {
            this.checkboxAll = false;
          }
        },
        deep: true
      },
    },
    computed: {

    },
    created() {
     
    },
    methods: {
      emitAddEventToParentScope() {
        this.$emit('addVisitor', this.canAddOthersMaterial , this.canAddMaterial);
      },
      toggleVisitor: function() {
        this.showVisitor = !this.showVisitor;
        //this.$emit('ifSpread', true);
      },
      toggleVisitorTrain: function(index) {
        if (this.$refs.child[index].style.display == 'none') {
          this.$refs.child[index].style.display = 'block';
          this.$refs.downArrow[index].style.display = 'none';
          this.$refs.upArrow[index].style.display = 'block';
        } else {
          this.$refs.child[index].style.display = 'none';
          this.$refs.downArrow[index].style.display = 'block';
          this.$refs.upArrow[index].style.display = 'none';
        }
      },
      showReason: function() {
        this.$emit('popupStatus', true);
      },
      changeState: function(e) {
        this.checkList = [];
        if (this.checkboxAll) {
          this.visitorDataList.forEach( (value, index) => {
            this.checkList.push(value.visitorId);
          })
        }
      },
      showReasonOne: function() {
        if (this.checkList.length == 1) {
          this.$emit('popupStatus', true, this.checkList);
        } else {
          this.$emit('popupTip', true, this.thisModalTip);
        }
      },
      showReasonAll: function() {
        this.$emit('popupGmModal', true);
      },
      approveAll: function() {
        if(this.checkList.length) {
          // console.log(this.checkList);
          const getAgreeList = {
            'invitationId': this.inviteId,
            'idList': this.checkList,
            'isPass': 1,
            'reason': ''
          }
          materialReview(getAgreeList).then((res) => {
            // console.log(res);
            // console.log(res.data.content.message);
            if (res.data.content.status == 1) {
             window.location.reload();
            } else {
             this.$emit('approveAllModal', true, res.data.content.message);
            }
          });
        }
      },
      approveAllList: function() {
        if(this.inviteId) {
          const getAgreeList = {
            'id': this.inviteId,
            'isPass': true,
            'reason': ''
          }
          checkPassOrReject(getAgreeList).then((res) => {
             if (res.data.content.status == 1) {
              window.location.reload();
             } else {
              this.$emit('approveAllListModal', true, res.data.content.message);
             }
          });
        }
      },
      getData(objData, ifEnable, canAddOthersMaterial, canAddMaterial, topdetail) {
        this.showAddInvisitor = ifEnable;
        this.canAddMaterial = canAddMaterial;
        this.canAddOthersMaterial = canAddOthersMaterial;
        this.isPrimary = topdetail.isPrimary;
        this.typeAreaRemark = topdetail.typeAreaRemark;
        this.isLimitSubmit = topdetail.isLimitSubmit;
        this.visitorDataList = objData;
        this.topDetail = topdetail;
        if (objData) {
          const newArrayMaterial = this.visitorDataList.map( function(item, index) {
           if (!item.isPriVisitor) {
             const newArray = item.materialOptionInfoList.filter(function(i) {
               return i.isCompany == false;
             });
             const rObj = {};
             rObj.isPersonMaterial = newArray;
             return rObj;
           }
          });
          this.newPerosonMaterial = newArrayMaterial;

          if (this.newPerosonMaterial.length) {
           //console.log(this.newPerosonMaterial)
           const materialAnswerTemplate = this.newPerosonMaterial.map( function(array, index) {
             if(array) {
               array.materialTwo = [];
               array.materialEnght = [];
               array.materialOne = [];
               const list = array.isPersonMaterial;
               const newList = list.map( function(item, index) {
                 if (item.materialType == 1) {
                   const newArrayList = JSON.parse(item.answer);
                   var materialTitleTemplate = item.materialTitleTemplate;
                   const AnswerTemplate = JSON.parse(item.materialAnswerTemplate)[newArrayList[0]];
                   const newObj = {
                     'topic': materialTitleTemplate,
                     'answer': AnswerTemplate,
                   }
                   array.materialOne.push(newObj);  
                 } else if (item.materialType == 2) {
                   const newArrayList = JSON.parse(item.answer);
                   var materialTitleTemplate = item.materialTitleTemplate;
                   const AnswerTemplate = JSON.parse(item.materialAnswerTemplate);
                   var newArrayTwo = [];
                   const answerIndex = newArrayList.map(function(view,index) {
                     newArrayTwo.push(AnswerTemplate[view]);
                   });
                   const newObj = {
                     'topic': materialTitleTemplate,
                     'answer': newArrayTwo,
                   }
                   array.materialTwo.push(newObj);
                 } else if (item.materialType == 8) {
                   const newArrayList = JSON.parse(item.answer);
                   var materialTitleTemplate = item.materialTitleTemplate;
                   var optionCode = item.optionCode;
                   const AnswerTemplate = JSON.parse(item.materialAnswerTemplate)[newArrayList[0]];
                   const status = newArrayList[0];
                   const newObj = {
                     'topic': materialTitleTemplate,
                     'answer': AnswerTemplate,
                     'optionCode': optionCode,
                     'status': status,
                   }
                   array.materialEnght.push(newObj);
                 }
               });
             }
             return array;
           });
           this.OtherInvitorPerosonMaterial = materialAnswerTemplate;
          }

          //isPriVisitor
          const arrList = [];
          for(var i=0;i<this.visitorDataList.length;i++) {
           const materialOptionInfoList = this.visitorDataList[i].materialOptionInfoList;
           const iscompany = [];
           const personList = [];
           const lessonList = this.visitorDataList[i].lessonList;
           this.lessonList = lessonList;
          //  console.log(this.lessonList);
           this.lessonOverdueLength = [];
           if (this.visitorDataList[i].isPriVisitor) {
             iscompany = materialOptionInfoList.filter(function(i) {
                 return i.isCompany == true;
             });
             personList = materialOptionInfoList.filter(function(i) {
                 return i.isCompany == false;
             });
             this.companyMaterial = iscompany;
             this.perosonMaterial = personList;

             const cardNumber = this.perosonMaterial.find((item, idx) => {
                if (item.optionCode == 3) {
                  return   item.answer;
                }           
             });
             this.isPriVisitorCardNumber = cardNumber;
           }
           const lessonOverdue = [];
           for (var j = 0; j<this.lessonList.length; j++) {
             if(this.lessonList[j].lessonStatus == 2) { 
              lessonOverdue.push(this.lessonList[j]);
             }
           }  
           arrList.push(lessonOverdue.length);
          }
          this.lessonOverdue = arrList;

          this.selectOption(this.companyMaterial,'company');
          this.selectOption(this.perosonMaterial,'person');
        }
      },
      selectOption(dataArray,status) {
        var rObj = {
          'materialTwo': [],
          'materialEnght': [],
          'materialOne': [],
        };
        // console.log(dataArray);
        if (dataArray.length) {
          var answerIndex = [];
          const materialAnswerTemplate = dataArray.map( function(item, index) {
            if(item) {
              if (item.materialType == 2) {
                const newArrayList = JSON.parse(item.answer);
                var materialTitleTemplate = item.materialTitleTemplate;
                var AnswerTemplate = JSON.parse(item.materialAnswerTemplate);
                var newObj = {};
                var newArrayTwo = [];
                const answerIndex = newArrayList.map(function(view,index) {
                  newArrayTwo.push(AnswerTemplate[view])  
                });
                newObj = {
                  'topic': materialTitleTemplate,
                  'answer': newArrayTwo,
                }
                rObj.materialTwo.push(newObj);
              } else if (item.materialType == 8) {
                const newArrayList = JSON.parse(item.answer);
                var materialTitleTemplate = item.materialTitleTemplate;
                var optionCode = item.optionCode;
                const AnswerTemplate = JSON.parse(item.materialAnswerTemplate)[newArrayList[0]];
                const status = newArrayList[0];
                const newObj = {
                  'topic': materialTitleTemplate,
                  'answer': AnswerTemplate,
                  'optionCode': optionCode,
                  'status': status,
                }
                rObj.materialEnght.push(newObj);
              } else if (item.materialType == 1) {
                const newArrayList = JSON.parse(item.answer);
                var materialTitleTemplate = item.materialTitleTemplate;
                var AnswerTemplate = JSON.parse(item.materialAnswerTemplate)[newArrayList[0]];
                const newObj = {
                  'topic': materialTitleTemplate,
                  'answer': AnswerTemplate, 
                }
                rObj.materialOne.push(newObj); 
              }
            }
          });
          //console.log(rObj);
          if (status == 'person') {
            this.answerListPerson = rObj;
          } else {
             this.answerListCompany = rObj;
          }
          // console.log( this.answerListPerson);
          // console.log( this.answerListCompany);
        }
      },
      lookImgs(answer) {
        const imgs = answer;
        const imgArr = JSON.parse(imgs);
        if (imgArr) {
          this.photoSwipeModal = true;
          this.$refs.photoSwiper.loadPhoto(imgArr);
          this.$emit('showLookImgs',true);
          this.$emit('editModalShow', true);
        }
      },
      lookAccessory(answer) {
        // console.log(e.target.dataset.value);
        const materials = answer;
        const newArray = JSON.parse(materials);
        var newArraymaterialList = [];
        var newArraymaterialName = [];
        for (var j=0; j<newArray.length; j++) {
          const current = newArray[j];
          const idx = current.lastIndexOf(",");
          const list = current.substring(0, idx);
          const name = current.substring(idx+1, current.length);
          if(list!='') {
            newArraymaterialList.push(list);
            newArraymaterialName.push(name);
          }
        }
        // console.log(newArraymaterialList);
        // console.log(newArraymaterialName);
        if(newArraymaterialList.length) {
          this.photoSwipeModal = true;
          this.$refs.photoSwiper.loadMaterial(newArraymaterialList,newArraymaterialName);
          this.$emit('showLookImgs',true);
          this.$emit('editModalShow', true);
        }
      },
      closePhoto() {
        this.$emit('editModalShow', false);
        this.photoSwipeModal = false;
      },
      hideVisitor(visitor,approver,gm) {
        // console.log(visitor,approver,gm);
        this.visitorListData = visitor ? true : false;
        // console.log(this.visitorListData);
        if (visitor || approver || gm) {
          this.showVisitorList = true;
        } else {
          this.showVisitorList = false;
        }
      },
      deleteVisitor(hasMaterialData, visitorIdData) {
        const hasMaterial = hasMaterialData == 0 ? false : true;
        const visitorId = visitorIdData;
        this.$emit('editModalShow', true);
        this.comifrmModal = true;
        const data = {
          'currentTxt': 'deleteOneVistor',
          "hasMaterial": hasMaterial,
          "visitorId": visitorId
        }
        this.$refs.detailDialogShow.loadDialogData(data); 
      },
      closeModal() {
        this.comifrmModal = false;
      },
      editVisitor(e,index) {
        const visitorid = this.visitorDataList[index].visitorId;
        this.editModal = true;
        this.$emit('editModalShow', true);
        this.isLoading = true;
        //alert(visitorid)
        getExternalVisitorInfo(visitorid).then((res) => {
          this.isLoading = false;
          if (checkNested(res, 'data', 'content', 'model')) {
           // console.log(res.data.content.model);
            this.currentVisitorData = res.data.content.model; 
            const areaId = this.topDetail.areaId;
            const typeId = this.topDetail.typeId;
            this.areaId = areaId;
            this.typeId = typeId;
            this.handleAreaChange(areaId, null);
          }          
        });           
      },
      handleAreaChange(id, event) {
        if (id) {
          // get material options
          getExternalMaterialOptions(this.areaId, this.typeId).then((res) => {
            if (checkNested(res, 'data', 'content', 'model')) {
              materialsInstance = new Materials(res.data.content.model);
              this.materials = materialsInstance.init();
              this.hasMaterialsToFill = this.materials.length > 0;
              // use spread syntax to copy array of object
              this.currentMaterials = materialsInstance.init();

              // if edit invite info
              const primaryVisitor = this.currentVisitorData;
              if (primaryVisitor) {
                const primaryVisitorMaterialAnswered = primaryVisitor.visitTicketVisitorMaterials;
                // console.log(primaryVisitor);
                this.currentVisitor.id = primaryVisitor.id;
                this.currentVisitor.contact = primaryVisitor.email || primaryVisitor.phoneNumber;
                this.currentVisitor.pickedContact = primaryVisitor.email ? this.$t('email') : this.$t('mobile');
                this.currentVisitor.userName = primaryVisitor.userName;
                this.currentVisitor.isPrimaryVisitor = primaryVisitor.isPrimaryVisitor
                // duplicated code:
                const initMaterials = this.currentMaterials.map(m => ({ ...m }));
                primaryVisitorMaterialAnswered.forEach((m, idx) => {
                  let materialTemplate = initMaterials.find(initM => initM.id === m.materialOptionId);
                  const index = initMaterials.findIndex(initM => initM.id === m.materialOptionId);
                  // const material = primaryVisitorMaterialAnswered[idx];
                  if (materialTemplate) {
                    materialTemplate = Object.assign({ ...materialTemplate }, { answer: m.answer, id: m.materialOptionId, trackId: m.id });
                    materialTemplate.answer = materialTemplate.materialType === 3 || materialTemplate.materialType === 4 || materialTemplate.materialType === 5 ? materialTemplate.answer : JSON.parse(materialTemplate.answer);
                    materialTemplate.answer = Materials.handleAnswerForDisplay(materialTemplate);
                    if (materialTemplate.materialType === 6) {
                      materialTemplate.names = materialTemplate.answer.map(a => a.split(',')[1]);
                    }
                    //console.log(materialTemplate);
                    initMaterials[index] = materialTemplate;
                  }
                });
                this.currentVisitor.materials = initMaterials;
                console.log(this.currentVisitor)
                // if (this.currentMaterials.length) {
                //   this.showPrimaryVisitorExtraField = true;
                // }
              }
            }
          });
        } else {
          this.areadId = -1;
        }
      },
      handleDeleteAnnex(data) {
        // console.log(data);
        const materials =  this.currentVisitor.materials;
        Materials.handleDeleteImgOrAnnex(data, materials);
      },
      handleDeleteImg(data) {
        const materials =  this.currentVisitor.materials;
        Materials.handleDeleteImgOrAnnex(data, materials);
      },
      handleAnswer(data) {
        // sync with this.currentMaterials
        const materials = this.currentVisitor.materials;
        Materials.handleAnswer(data, materials);
      },
      handleSaveCurrent(data) {
        let flag = true;
        let materials = [];
        if (data.isPrimaryVisitor) {
          this.currentVisitor.materials.forEach((m) => {
            m.skipCheck = Materials.checkIfNeedToSkip(m, this.currentVisitor.materials);
          });
          materials = Materials.checkIsRequiredFinished(this.currentVisitor.materials, true); // true: param isForExternal = true
        } else {
          materials = this.currentVisitor.materials.filter(m => !m.isCompany);
          materials.forEach((m) => {
            m.skipCheck = Materials.checkIfNeedToSkip(m, materials);
          });
          materials = Materials.checkIsRequiredFinished(materials, true); // true: param isForExternal = true
        }
        flag = materials.findIndex(m => m.isError) === -1;
        this.isNameEmpty = !this.currentVisitor.userName;
        flag = flag && this.currentVisitor.userName !== '' && data.validContact;
        // console.log(`flag: ${flag}`);
        if (flag) {
          this.$emit('showAlertModal', true, this.currentVisitor);
          this.editModal = false;
          this.$emit('closeEditModal',false);
          window.scroll(0, 0);
        } else {
          this.$emit('showAlertModal', false);
        }  
      },
      closeEdit(status) {
        this.editModal = false;
        this.$emit('closeEditModal',false);
      },
      // QR Code Related, Added by Andy
      toggleQR(code) {
        this.isQRShow = !this.isQRShow;
        document.body.classList.toggle('modal-open');
        this.currentQR = code ? code : 'empty_qr';
      },
      updateCardNumber(carNumber, visitorId, carNumberIsRequired) {
        Bus.$emit('carNumber',carNumber, true, visitorId, carNumberIsRequired);
      }
    },
  };
</script>

<style scoped lang="scss">
@import "../../scss/variables.scss";
input[type=number] {  
  appearance:textfield;  
}  
input[type=number]::-webkit-inner-spin-button,  
input[type=number]::-webkit-outer-spin-button {  
  appearance: none;  
  margin: 0;  
} 
.visitor-content:not(.passed-invite) {
  padding-bottom: 27px;
}
.visitor-list-view {
}
.visitor-empty {
  text-align: center;
  margin-bottom: 85px;
  .icon {
    width: 86px;
    height: 86px;
    margin: 0 auto 15px;
    background: url('../../assets/images/visitor-empty.svg') no-repeat;
  }
  h5,
  p {
    font-size: 13px;
  }
  h5 {
    font-weight: bold;
  }
  .btn-back {
    width: 125px;
    height: 42px;
    border-radius: 5px;
    font-size: 15px;
    line-height: 28px;
    color: #fff;
    margin-top: 5px;
    background-image: linear-gradient(69deg, #f36443, #e42029);
  }
}
.course-info {
  border-top: 1px solid rgba(101, 101, 101, 0.15);
  position: relative;
  .title {
    span {
      padding-left: 7px;
      font-size: 13px;
      font-weight: normal;
      color: #4a4a4a;
    }
    img {
      width: 12px !important;
    }
  }
  .btn-toggle-train {
    cursor: pointer;
    position: absolute;
    top: 15px;
    right: 0;
    span {
      font-size: 13px;
    }
    i {
      transform: scale(.75,.75);
      margin-left: 5px;
      font-size: 12px;
      display: inline-block;
      margin-right: -2px;
    }
  }
}
.reject-info {
  border-top: 1px solid rgba(101, 101, 101, 0.15);
  padding: 15px 0;
}
.operation {
  margin: 15px 0 15px 0;
  padding: 0;
  div {
    width: 45%;
    cursor: pointer;
    span {
      font-size: 15px;
      font-weight: 600;
    }
  }
  div:nth-of-type(2) {
    margin-left: 10%;
  }
  .status-only {
    width: 100% !important;
  }

  .delete {
    height: 40px;
    line-height: 40px;
    border-radius: 5px;
    border: solid 1px #979797;
    text-align: center;
    span {
      color: #929292;
    }
  }
  .onlyupdateCardId,
  .modify {
    height: 40px;
    line-height: 40px;
    border-radius: 5px;
    border: solid 1px #e42029;
    text-align: center;
    span {
      color: #e42029;
    }
  }
  .onylydetail-status {
    background-image: linear-gradient(72deg, #f36443, #e42029);
    height: 40px;
    line-height: 40px;
    border-radius: 5px;
    border: none;
    text-align: center;
    img {
      vertical-align: middle;
      margin-right: 10px;
    }
    span {
      color: #fff;
      display: inline-block;
      vertical-align: middle;
    }
  }
}
.handleBtn {
  width: 100%;
  margin: 0;
  border-top: 1px solid rgba(101, 101, 101, 0.15);
  padding: 15px 12px;
  vertical-align: middle;
  cursor: pointer;
  .onlyupdateCardId {
    cursor: pointer;
    width: 100%;
    padding: 0 10%;
    text-align: center;
    background: #fff;
    border: 1px solid #e42029;
    height: 40px;
    line-height: 40px;
    border-radius: 5px;
    span {
      color: #e42029;
      font-size: 14px;
      font-weight: 600;
    }
  }
  .updateCardId {
    margin: 0;
    width: 45%;
    text-align: center;
    background: #fff;
    border: 1px solid #e42029;
    height: 40px;
    line-height: 40px;
    border-radius: 5px;
    padding: 0;
    span {
      color: #e42029;
      font-size: 14px;
      font-weight: 600;
    }
  }
}


.detail-status {
  width: 45%;
  margin-left: 10%;
  margin-right: 0;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  padding: 0;
  div {
    text-align: center;
    border-radius: 5px;
    height: 40px;
    line-height: 40px;
    background-image: linear-gradient(78deg, #f36443, #e42029);
    img {
      margin-right: 5px;
      vertical-align: middle;
    }
    span {
      font-size: 14px;
      color: #fff;
      font-weight: 600;
      vertical-align: middle;
    }
  }
}
.view-header.visiteInformation {
  position: relative;
  margin-bottom: 0;
  h4 {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 0;
  }
  .btn-toggle {
    position: absolute;
    top: 0;
    right: 0;
    span {
      font-size: 13px;
    }
    i {
      transform: scale(.75,.75);
      margin-left: 5px;
      font-size: 11px;
    }
  }
}
.visitor-list {
  width: 100%;
  padding: 0 20px;
  color: #4a4a4a;
  .view-content {
    margin-top: 20px;
  }
  .visitor-row {
    border-radius: 4px;
    background: #fff;
    font-size: 13px;
    box-shadow: 0 0 15px rgba(100,100,100,.1);
    position: relative;
    margin-bottom: 20px;
    line-height: 1;
    padding-bottom: 10px;
    h5 {
      font-size: 13px;
      font-weight: bold;
      margin-bottom: 15px;
      line-height: 1;
    }
    .visitor-status  {
      width: 66px;
      height: 30px;
      display: block;
      color: #fff;
      position: absolute;
      top: 0;
      right: 0;
      border-radius: 0 4px 0 8px;
      text-align: center;
      line-height: 30px;
      overflow: hidden;
      background-image: linear-gradient(69deg, #f36443, #e42029);
      &.deleteOneVistor {
        top: 10px;
        right: 20px;
        background: #fff;
        color: #e42029;
        border: 1px solid #e42029;
        border-radius: 17px;
        cursor: pointer;
      }
      &:after {
        content: '';
        display: block;
        position: absolute;
        bottom: -11px;
        left: -11px;
        width: 22px;
        height: 22px;
        border-radius: 11px;
        background: rgba(255,255,255,0.4);
      }
      &.status-grey {
        background-image: linear-gradient(69deg, rgba(146, 146, 146, 0.61), #9b9b9b);
      }
    }
    .name {
      margin-bottom: 15px;
      margin-left: 0;
      align-items: center;
      padding: 18px 20px;
      margin: 0;
      border-bottom: 1px solid rgba(101, 101, 101, 0.15);
      & > div:first-child {
        margin-right: 10px;
      }
      label {
        font-weight: bold;
      }
      input.input-checkbox[type='checkbox'] {
        width: 23px;
        height: 23px;
        appearance: none;
        background-color: #fff;
        outline: none;
        vertical-align: text-bottom;
        margin-bottom: -4px;
        margin-right: 7px;
        background: url('../../assets/images/copy-21.png') no-repeat center;
      }
      input.input-checkbox[type='checkbox']:checked {
        background: url('../../assets/images/11-copy.png') no-repeat center;
      }
      label {
        margin: 0;
      }
    }
    .detail-info {
      padding: 0 20px;
      .company-info {
        padding-top: 15px;
        border-bottom: 1px solid rgba(101, 101, 101, 0.15);
        span {
          cursor: pointer;
        }
      }
      .personal-info {
        padding-top: 15px;
        //border-bottom: 1px solid rgba(101, 101, 101, 0.15);
        span {
          cursor: pointer;
        }
      }
      .course-info {
        border-top: 1px solid rgba(101, 101, 101, 0.15);
        padding-top: 15px;
      }
    }
    dl {
      margin-bottom: 8px;
      dt {
        padding-right: 0;
        font-weight: normal;
        color: #929292;
        font-size: 13px;
        line-height: 18px;
      }
      .col-3 {
        color: #929292;
        font-size: 13px;
      }
      div {
        color: #929292;
      }
      dd {
        line-height: 18px;
        &.info-text {
          padding-left: 0;
          .lookImgs {
            text-decoration: underline;
            color: #e42029;
          }
        }
        &.col-3 {
          text-align: right;
          padding-left: 0;
          span {
            max-width: 52px;
          }
        }
      }
    }
    .approver-info {
      img {
        border-radius: 50%;
        width: 34px;
        height: 34px;
        border: 1px solid #eee;
        margin-right: 10px;
      }
      .status {
        width: 100%;
        height: 28px;
        border-radius: 14px;
        background-color: #f4f4f4;
        display: inline-block;
        line-height: 28px;
        font-size: 12px;
        text-align: center;
        color: #9b9b9b;
      }
      .status-red {
        color: #e42029;
      }
    }
    .info-content {
      span {
        & + span {
          padding-left: 10px;
        }
      }
      .status {
        text-align: right;
        color: #929292;
      }
    }
  }
}
.visitor-content {
  .view-main {
    box-shadow: 0 0px 15px rgba(100, 100, 100, 0.1);
    padding: 20px 0;
  }
}
.visitor-content.hide-visitor {
  padding-bottom: 0;
  .view-main {
    border-radius: 10px;
    // padding-bottom: 5px;
    margin-bottom: 20px;
    box-shadow: 0 10px 25px rgba(100,100,100,.1);
  }
}
.handle-bar {
  background: #fff;
  padding: 15px 20px;
  box-shadow: 0 0 15px rgba(100,100,100,.15);
  align-items: center;
  label.checkAll {
    font-size: 16px;
    color: #929292;
    margin: 0;
    input[type='checkbox'] {
      width: 23px;
      height: 23px;
      appearance: none;
      background-color: #fff;
      outline: none;
      background: url(../../assets/images/copy-21.png) no-repeat center;
      vertical-align: text-bottom;
      margin-bottom: -1px;
      margin-right: 7px;
    }
    input[type='checkbox']:checked {
      border: none;
      background: url(../../assets/images/zhengque.png) no-repeat center;
    }
  }
  .btn {
    width: 100%;
  }
  .refuse {
    cursor: pointer;
    padding-right: 10px;
    .btn {
      &:hover {
        color: #9b9b9b;
      }
    }
  }
  .approve {
    cursor: pointer;
    padding-left: .1em;
    padding-right: .1em;
  }
}
.show-popup {
  position: absolute;
}
.reason {
  display: none;
}
.visitor-row {
  .detail-info {
    .title {
      img {
        vertical-align: text-top;
        margin-right: 5px;
        width: 16px;
      }
    }
  }
}

.visit-show {
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top:0;
  z-index: 1032;
  background:rgba(0, 0, 0, 0.4);
  .invisitListContent {
    position: absolute;
    bottom: 0;
  }
}

.spcial {
  padding: 0;
}
.redColor {
  span {
    color: #e42029;
  }
}
.addBtn {
  width: 100%;
  margin: 20px auto;
  background-image: linear-gradient(81deg, #f36443, #e42029);
  height: 46px;
  text-align: center;
  color: #fff;
  line-height: 46px;
  border-radius: 5px;
  cursor: pointer;
  i {
    margin-right: 7px;
  }
  span {
    font-size: 15px;
    font-weight: 600;
    color: #fff;
  }
}
.tips {
  margin-top: 6px;
  margin-bottom: 0;
  @include respond-to('md') {
    margin-bottom: 10px;
  }
  i {
    font-size: 12px;
    color: #929292;
    margin-right: 5px;
  }
  span {
    font-size: 12px;
    color: #929292;
  }
}

// QR Code Related Code, Added by Andy
.qr-wrapper {
  z-index: 1000;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(34, 34, 34, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  .qr-content {
    border-radius: 4px;
    background: #fff;
    color: #4a4a4a;
    text-align: center;
    width: 84%;
    max-width: 380px;
    position: relative;
    padding: 20px 0;
    @include respond-to('s-max') {
      margin-top: 20%;
    }
    margin-top: 60px;
    .close-wrapper {
      position: absolute;
      right: 10px;
      top: 3px;
      text-align: right;
      height: 24px;
      cursor: pointer;
      .icon-close {
        font-size: 24px;
        padding-right: 5px;
      }
    }
    .qr-scroll {
      max-height: 500px;
      @include respond-to('s-max') {
        max-height: 400px;
      }
      overflow: auto;
    }
    .qr-desc {
      width: 73%;
      margin: auto;
      border-top: 1px solid #f0f1f2;
      margin-top: -20px;
      padding-bottom: 20px;
      p {
        &:first-child {
          font-size: 16px;
          font-weight: bold;
          margin-top: 25px;
          margin-bottom: 10px;
        }
        &:nth-child(2) {
          font-size: 13px;
        }
        &:last-child {
          background: #f8f8f8;
          border: 1px dashed #d3d3d3;
          border-radius: 4px;
          background-color: #f8f8f8;
          font-size: 12px;
          padding: 5px 10px 5px 20px;
          text-align: left;
          color: #929292;
        }
      }
    }
  }
}

</style>
